function ErrorComponent() {
  return (
    <div className="text-center">
      <p className="bg-red-500 text-white">
        Error - Du har ikke tilgang her. Vennligst logg ut og inn igjen.
      </p>
    </div>
  );
}

export default ErrorComponent;
